import {Component, OnInit} from '@angular/core';
import {Card, CardStatusInfo, CardWithSecondaries, CustomerOverviewCardContainer} from "../../../dto/card";
import {ActivatedRoute, Router} from '@angular/router';
import {CardsService} from '../../services/cards.service';
import {Location} from '@angular/common';
import {
  toCardExpireDateString,
  toDateString,
  toDateTimeString,
  toDateTimeStringNoSeconds
} from "../../../providers/app-date-adapter";
import {MatDialog} from '@angular/material/dialog';
import {EventLogService} from '../../../services/crud/event-log.service';
import {EventLog} from '../../../dto/event-log';
import {RoleService} from '../../../services/role.service';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {AddressChangeStatus, AddressStatus, IdentLevel} from "../../../dto/ident-status";
import {ToastService} from 'angular-toastify';
import {GpsCardStatus, GpsCardStatusHelper} from '../../../dto/gps-card-status';
import {CardDeclineStats, CardLimitStats, QuickBalance} from "../../../dto/CardbroGateway/card-info";
import {Pin} from '../../../dto/pin';
import {HttpErrorResponse} from '@angular/common/http';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {ProductService} from '../../services/product.service';
import {CardAcceptorListDto, FeeGroup, LimitGroup} from "../../../dto/limitGroup";
import {Customer} from '../../../dto/customer';
import {
  StatusChangeReasonDialogComponent
} from '../../../shared/status-change-reason-dialog/status-change-reason-dialog.component';
import {Product} from '../../../dto/product';
import {ObjectComment} from "../../../dto/object-comment";
import {ObjectCommentsService} from "../../services/object-comment.service";
import moment from "moment";
import {
  IncludeSecondariesDialogComponent
} from "../../../shared/include-secondaries-dialog/include-secondaries-dialog.component";
import {environment} from "../../../../environments/environment";


@Component({
  selector: 'app-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.css']
})
export class CardViewComponent implements OnInit {

  isLoading = false;
  isLoadingOtherCards = false;
  card: CardWithSecondaries;

  fields1 = [
    { header: 'Token', cell: (row: Card) => `${row.token}`, copyCellActive: (row: Card) => true, },
    {
      header: 'Primary Token',
      //icon: (row: Card) => row.primaryCardId ? "visibility" : null,
      link: (row: Card) => row.primaryCardId ? '../../cards/' + row.primaryCardId : null,
      cell: (row: Card) => row.primaryCardId ? `➡️ ${row.primaryToken}` : '(This is a primary card)',
      copyCellActive: (row: Card) => !!row.primaryCardId,
      cellColor: (row: Card) => row.primaryCardId ? '#2222cc' : null,
    },

  ] as ContentRowField<Card>[];

  fields2 = [
    { header: 'Card name', cell: (row: Card) => `${row.cardName || ''}` },
    { header: 'PAN'      , cell: (row: Card) => `${row.maskedPAN || '(unknown)' }` },
    { header: 'Product', cell: (row: Card) => `${row.product.internalName}` },
    { header: 'Company', cell: (row: Card) => `${row.companyName}` },
    { header: 'Exp date', cell: (row: Card) => `${toCardExpireDateString(row.expireDate) || ''}` },
    { header: 'Card Type', cell: (row: Card) => `${row.cardTypeName || '(unknown)'}`},
    { header: 'Status', cell: (row: Card) => `${row.statusName || ''}` },

    { header: 'Creation Date', cell: (row: Card) => `${toDateTimeStringNoSeconds(row.creationDate) || ''}` },
    { header: 'Activation date', cell: (row: Card) => `${toDateTimeStringNoSeconds(row.activationDate) || ''}` },
    { header: 'Next Annual Fee', cell: (row: Card) => `${toDateString(row.nextAnnualFeeDateDisplayed || row.nextAnnualFeeDate) || ''}` } as ContentRowField<Card>,

  ] as ContentRowField<Card>[];


  fieldsSecondaries = [
    { header: 'GPS Status',
      cell: row => this.gpsCardStatusHelper.getIcon(row.gpsCardStatus as GpsCardStatus) + " " + this.gpsCardStatusHelper.getText(row.gpsCardStatus as GpsCardStatus),
    },
    { header: 'Secondary Token',
      cell: row => `${row.token}`,
      copyCellActive: row => true,
      link: row => row.id ? '../../cards/' + row.id : null,
    },
    { header: 'Product', cell: (row: CardStatusInfo) => `${row.productName || '(unknown)'}`},


  ] as ContentRowField<CardStatusInfo>[];


  fieldsOrder = [
    { header: 'Customer', icon: (row: Card) => 'visibility', link: (row: Card) => '../../customers-overview/' + (row.customer.id || ''), cell: (row: Card) => `${row.customer.firstName + ' ' + row.customer.lastName || ''}` } as ContentRowField<Card>,
    { header: 'Ident Level', iconColor: (row: Card) => {
        switch (row.customer.identLevel) {
          case IdentLevel.Fdd:
            return '#8bc34a';
          case IdentLevel.Edd:
            return '#207033';
          default:
            return null;
        }
      }, icon: (row: Card) => {
        switch (row.customer.identLevel) {
          case IdentLevel.Fdd:
            return 'beenhere';
          case IdentLevel.Edd:
            return 'thumb_up_alt';
          default:
            return null;
        }
      }, cell: (row: Card) => {
        switch (row.customer.identLevel) {
          case IdentLevel.Sdd:
            return 'SDD';
          case IdentLevel.Fdd:
            return 'FDD';
          case IdentLevel.Edd:
            return 'EDD';
          default:
            return 'unknown';
        }

      }
    },

    {
      header: 'Address Status',
      iconColor: (row: Card) => {

        if (row.customer.addressStatus == AddressStatus.Confirmed) {
return '#8bc34a';
}
        if (row.customer.addressStatus == AddressStatus.WaitingForDocuments) {
return '#4a82c3';
}
        if (row.customer.addressStatus == AddressStatus.PendingCheck) {
return '#684ac3';
}

        return '#d04848';
      },
      icon: (row: Card) => {
        if (row.customer.addressStatus == AddressStatus.Confirmed) {
return 'place';
}
        if (row.customer.addressStatus == AddressStatus.WaitingForDocuments) {
return 'not_listed_location';
}
        if (row.customer.addressStatus == AddressStatus.PendingCheck) {
return 'not_listed_location';
}

        return 'not_listed_location';
      }, cell: (row: Card) => {
        if (row.customer.addressStatus == AddressStatus.Confirmed) {
return 'Confirmed';
}
        if (row.customer.addressStatus == AddressStatus.WaitingForDocuments) {
return 'Waiting for documents';
}
        if (row.customer.addressStatus == AddressStatus.PendingCheck) {
return 'Pending check';
}

        return 'Unconfirmed';
      }},


    {
      header: 'Address Change Status',
      iconColor: (row: Customer) => {

        if (row.addressChangeStatus == AddressChangeStatus.WaitingForDocuments) {
          return '#4a82c3';
        }
        if (row.addressChangeStatus == AddressChangeStatus.PendingCheck) {
          return '#684ac3';
        }

        return '#ffffff';
      },
      icon: (row: Customer) => {
        if (row.addressChangeStatus == AddressChangeStatus.WaitingForDocuments) {
          return 'not_listed_location';
        }
        if (row.addressChangeStatus == AddressChangeStatus.PendingCheck) {
          return 'not_listed_location';
        }

        return '';
      }, cell: (row: Customer) => {
        if (row.addressChangeStatus == AddressChangeStatus.WaitingForDocuments) {
          return 'Waiting for documents';
        }
        if (row.addressChangeStatus == AddressChangeStatus.PendingCheck) {
          return 'Pending check';
        }

        return '';
      }},




    { header: 'Order', icon: (row: Card) => 'visibility', link: (row: Card) => '../../orders/' + (row.orderId || ''), cell: (row: Card) => `${row.orderId || ''}` },
    { header: 'Invoice', icon: (row: Card) => 'visibility', link: (row: Card) => '../../invoices/' + (row.order.invoiceId || ''), cell: (row: Card) => `${row.order.invoiceNumber || ''}` },

    { header: 'Order date', cell: (row: Card) => `${toDateString(row.orderDate) || ''}` },

    { header: 'Last Payment Reminder', cell: (row: Card) => `${(row.order.paymentEmailReminders && row.order.paymentEmailReminders[row.order.paymentEmailReminders.length - 1]) || ''}` },
  ] as ContentRowField<Card>[];

  public toDateTimeString = toDateTimeString;
  public logs: Array<EventLog>;
  currentLimitGroup: string|null;
  newLimitGroupToSelect: string|null;

  currentWhiteList: string|null;
  newWhiteListToSelect: string|null;
  currentBlackList: string|null;
  newBlackListToSelect: string|null;

  public gpsCardStatus = GpsCardStatus;
  currentGpsStatus: GpsCardStatus|null;
  currentGpsStatusCached: GpsCardStatus|null;
  newGpsStatusToSet: GpsCardStatus|null;

  public isQueryingWhiteList = false;
  public isQueryingBlackList = false;

  public _isQueryingCardLimitStats = false;
  public _isQueryingCardFees = false;
  public _isQueryingCardPermsGroup = false;
  public _isQueryingPinStatus = false;
  public _isQueryingCardPerms = false;
  public _isUnblockingPin = false;
  public _isActivatingCard = false;
  public isQueryingLimitGroup = false;
  public _isQueryingCardStatus = false;
  public _isUpgradingCard = false;
  public currentGpsStatusDate: Date|null;
  public limitStats: CardLimitStats | null;
  public cardFeeGroup: string|null;
  public cardPermsGroup: string|null;
  public cardId: number|null;
  public pin: Pin|null;
  public cardPerms: string|null;
  public gpsCardStatusHelper = GpsCardStatusHelper;
  public feeGroups: FeeGroup[] = [];
  public newFeeGroup: string | null;
  public newProductId: number|null;
  public products: Product[] = [];
  public _isChangingProduct = false;
  public kingPlusUpgradeCost: number|null = null;
  public cardBalanceLastKnown: QuickBalance|null;
  public otherCards: Card[] = [];
  public newPrimaryCardId: number|null = null;
  public _isLinkingCard = false;
  public balanceTransferDestinationCardId: number | null = null;
  public _isBalanceTransferring = false;
  public cardComments: ObjectComment[] = [];
  public commentsCardTarget = 6;
  public _isQueryingCardDeclineStats = false;
  public declineStats: CardDeclineStats|null = null;

  public imageUrl: string|null;
  public limitGroups: LimitGroup[] = [];
  public whiteLists: CardAcceptorListDto[] = [];
  public blackLists: CardAcceptorListDto[] = [];


  constructor(
    private router: Router,
    private location: Location,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private cardsService: CardsService,
    private roleService: RoleService,

    private logService: EventLogService,
    private _toastService: ToastService,
    private productService: ProductService,
    private objectCommentsService: ObjectCommentsService,
  ) { }


  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  ngOnInit() {

    this.route.paramMap.subscribe(
      (routeParam) => {
        const id = parseInt(this.route.snapshot.paramMap.get('id'));
        if ( id != this.cardId) {
          this.currentGpsStatus = null;
          this.cardId = id;
        }

        this.loadData();
      },
      (err) => { }
    );

    //const id = parseInt(this.route.snapshot.paramMap.get("id"));
    //this.cardId = id;

    //this.loadData();

  }

  loadComments() {
    this.objectCommentsService.getForObject(this.cardId, this.commentsCardTarget).subscribe((data) => {
      this.cardComments = data;
    });
  }

  loadData() {
    this.isLoading = true;

    this.productService.getBlackLists().subscribe(data => this.blackLists = data, err => this.blackLists = []);
    this.productService.getWhiteLists().subscribe(data => this.whiteLists = data, err => this.whiteLists = []);

    this.productService.getLimitGroups().subscribe(data => this.limitGroups = data);

    this.cardsService.get(this.cardId).subscribe(result => {
      this.card = result;
      if ( this.card.product.logoFileName)
        this.imageUrl = environment.apiUrl + this.card.product.logoFileName;

      this.currentGpsStatusDate = this.card.gpsCardStatusDate;

      this.currentWhiteList = this.card.whiteListCode;
      this.currentBlackList = this.card.blackListCode;

      this.logService.get( 16 /* Card */, this.card.id ).subscribe( data => {
        this.logs = data;
      });

      this.cardsService.getGpsCardStatusCached(this.card.token).subscribe(gpsCardStatusCached => {
        this.currentGpsStatusCached = gpsCardStatusCached;
      });

      this.isLoading = false;

      this.getCardPerms();

      this.productService.getAll().subscribe(products => {
        this.products = products.data;
        this.newProductId = this.card.productId;
      });

      this.cardsService.getForCustomer(this.card.customerId).subscribe(cards => {
        this.isLoadingOtherCards = true;
        const otherCards = [];
        cards.forEach(value => {

          let isMySecondary = false;
          this.card.secondaryCards.forEach(secondaryCard => {
            if (secondaryCard.id === value.id) {
              isMySecondary = true;
            }
          });

          if ( !isMySecondary && value.id != this.card.id /*&& value.id != this.card.primaryCardId*/ ) {
            otherCards.push(value);
          }
        });
        this.otherCards = otherCards;
        this.isLoadingOtherCards = false;
      });


      if ( this.card.product.productKey == 'king') {
        this.cardsService.getUpgradeCost(this.card.token, 'kingplus').subscribe(cost => {
          this.kingPlusUpgradeCost = cost;
        }, err => {});
        this.cardsService.getLastKnownAvailableBalance(this.card.token).subscribe(cost => {
          this.cardBalanceLastKnown = cost;
        }, err => {});
      }

    });

    this.fetchCardLimitStats();
    this.getCardDeclineStats();
    this.productService.getFeeGroups().subscribe(data => this.feeGroups = data, err => this.feeGroups = []);

    this.loadComments();


  }

  returnBack() {
    this.location.back();
  }

  showLogs() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance']);
  }

  setLimitGroup(newLimitGroup: string) {
    this.isQueryingLimitGroup = true;
    this.cardsService.setLimitGroup(this.card.token, newLimitGroup).subscribe(ok => {
      this.isQueryingLimitGroup = false;
      this._toastService.success('Card ' + this.card.token + ' Limit Group was set to ' + newLimitGroup);

      this.currentLimitGroup = newLimitGroup;


      this.fetchCardLimitStats();

    }, err => {
      this.isQueryingLimitGroup = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  cardStatusChangedCallback(ok, gpsCardStatusToSet: GpsCardStatus, includeSecondaries: boolean|null) {

    this._isQueryingCardStatus = false;
    this._toastService.success('Card ' + this.card.token + ' status was set to ' + gpsCardStatusToSet);

    this.currentGpsStatus = gpsCardStatusToSet;
    this.currentGpsStatusCached = gpsCardStatusToSet;
    this.currentGpsStatusDate = new Date();

    if ( includeSecondaries === true) {
      this.card.secondaryCards.forEach(value => value.gpsCardStatus = gpsCardStatusToSet);
    }


    this.loadComments();
  }


  setGpsCardStatus(gpsCardStatusToSet: GpsCardStatus, confirmIrreversible: boolean = false, reason: string|null = null, reasonStatement: string|null = null, includeSecondaries: boolean|null = null) {

    this._isQueryingCardStatus = true;

    this.cardsService.setGpsCardStatus(this.card.token, gpsCardStatusToSet, confirmIrreversible, reason, reasonStatement, includeSecondaries).subscribe(ok => this.cardStatusChangedCallback(ok, gpsCardStatusToSet, includeSecondaries), err => {

      if (err instanceof HttpErrorResponse && err.status == 403 && err.error.message === 'insufficient_permissions') {

        this._toastService.error('Insufficient permissions, need ' + err.error.requiredRoles);
        this._isQueryingCardStatus = false;
        return;
      } else if (err instanceof HttpErrorResponse && err.status == 422 && err.error.message === 'reason_needed') {
        this._toastService.warn('this status needs a internal reason');

        this.dialog.open( StatusChangeReasonDialogComponent, {data:{
            title: 'Confirm Card Status ' + gpsCardStatusToSet,
            text: 'Card Status ' + gpsCardStatusToSet + ' needs a reason (internal display only).',
            subText: 'Please enter a internal reason for the status change.',
            confirm: 'Ok',
            cancel: 'Cancel',
            selectableReasons: err.error.possibleReasons,
            customReasonAllowed: err.error.customReasonAllowed,
          }}).afterClosed().subscribe( result => {
          if ( result ) {
            this.setGpsCardStatus(gpsCardStatusToSet, confirmIrreversible, result, reasonStatement, includeSecondaries);
          } else {
            this.newGpsStatusToSet = this.currentGpsStatus || this.currentGpsStatusCached;
            this._toastService.info('Card status will not be changed');
            this._isQueryingCardStatus = false;
          }
        } );

      } else if (err instanceof HttpErrorResponse && err.status == 422 && err.error.message === 'reason_statement_needed') {
        this._toastService.warn('this status needs a reason to display on the card statement');

        this.dialog.open( StatusChangeReasonDialogComponent, {data:{
            title: 'Confirm Card Status ' + gpsCardStatusToSet,
            text: 'Card Status ' + gpsCardStatusToSet + ' needs a reason to show on the card statement.',
            subText: 'Please enter a reason to be shown on the card statement for the status change.',
            confirm: 'Ok',
            cancel: 'Cancel',
            selectableReasons: err.error.possibleReasons,
            customReasonAllowed: err.error.customReasonAllowed,
          }}).afterClosed().subscribe( result => {
          if ( result ) {
            this.setGpsCardStatus(gpsCardStatusToSet, confirmIrreversible, reason, result, includeSecondaries);
          } else {
            this.newGpsStatusToSet = this.currentGpsStatus || this.currentGpsStatusCached;
            this._toastService.info('Card status will not be changed');
            this._isQueryingCardStatus = false;
          }
        } );

      }


      else if (err instanceof HttpErrorResponse && err.status == 422 && err.error.message === 'confirmation_needed') {
        this._toastService.warn('this status needs confirmation');

        this.dialog.open( ConfirmDialogComponent, {data:{
            title: 'Confirm Card Status ' + gpsCardStatusToSet,
            text: 'Card Status ' + gpsCardStatusToSet + ' is irreversible. Are you sure you want to set this status?',
            confirm: 'Ok',
            cancel: 'Cancel'
          }}).afterClosed().subscribe( result => {
          if ( result == 'ok' ) {
            this.setGpsCardStatus(gpsCardStatusToSet, true, reason, reasonStatement, includeSecondaries);
          } else {
            this.newGpsStatusToSet = this.currentGpsStatus || this.currentGpsStatusCached;
            this._toastService.info('Card status will not be changed');
          }
        } );

      }
      else if (err instanceof HttpErrorResponse && err.status == 422 && err.error.message === 'include_secondaries_question') {
        this._toastService.warn('Propagate to secondary cards?');

        this.dialog.open( IncludeSecondariesDialogComponent, {data:{
            title: 'Set Card Status on secondary cards?',
            text: 'Do you also want to set status ' + gpsCardStatusToSet + ' on secondary cards?',
            secondaryTokens: err.error.secondaryTokens,
          }}).afterClosed().subscribe( result => {
          if ( result == 'yes' ) {
            this.setGpsCardStatus(gpsCardStatusToSet, true, reason, reasonStatement, true);
          } else {
            this.setGpsCardStatus(gpsCardStatusToSet, true, reason, reasonStatement, false);
          }
        } );

      }
      else {
        this._toastService.error(err.error.message || err.message || err.error || err);
      }

      this._isQueryingCardStatus = false;


    });
  }

  fetchCardLimitStats() {
    this._isQueryingCardLimitStats = true;
    this.cardsService.getCardLimitStats(this.cardId).subscribe(limitStats => {
      this._isQueryingCardLimitStats = false;
      this.limitStats = limitStats;

      this.currentLimitGroup = limitStats.limitGroupCode;

    }, err => {
      this._isQueryingCardLimitStats = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }


  getCardDeclineStats() {
    this._isQueryingCardDeclineStats = true;
    this.cardsService.getCardDeclineStats(this.cardId, moment().subtract(6, 'months'), moment()).subscribe(declineStats => {
      this._isQueryingCardLimitStats = false;
      this.declineStats = declineStats;
    }, err => {
      this._isQueryingCardDeclineStats = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  getCardPinStatus() {
    this._isQueryingPinStatus = true;
    this.cardsService.getCardPinStatus(this.card.token).subscribe(pin => {
      this._isQueryingPinStatus = false;
      this.pin = pin;
    }, err => {
      this._isQueryingPinStatus = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  getCardPerms() {
    this._isQueryingCardPerms = true;
    this.cardsService.getCardPerms(this.card.token).subscribe(perms => {
      this._isQueryingCardPerms = false;
      this.cardPerms = perms;
    }, err => {
      this._isQueryingCardPerms = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  unblockPin() {
    if ( this.pin == null ) {
      this._toastService.error('Query PIN status first');
      return;
    }

    if ( !this.pin.isBlocked ) {
      this._toastService.warn('PIN is not blocked');
      return;
    }

    this._isUnblockingPin = true;
    this.cardsService.unblockPin(this.card.token).subscribe(_ => {
      this._isUnblockingPin = false;
      this.pin.isBlocked = false;
      this._toastService.success('PIN has been unblocked');
    }, err => {
      this._isUnblockingPin = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  activateCard() {

    this._isActivatingCard = true;
    this.cardsService.activateCard(this.card.token).subscribe(_ => {
      this._isActivatingCard = false;
      this._toastService.success('Card has been activated');
    }, err => {
      this._isActivatingCard = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  queryLimitGroupFromPortal() {
    this.isQueryingLimitGroup = true;
    this.cardsService.getLimitGroup(this.card.token).subscribe(limitGroup => {
      this.isQueryingLimitGroup = false;
      this.currentLimitGroup = limitGroup;
    }, err => {
      this.isQueryingLimitGroup = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  queryCardStatusFromPortal() {
    this._isQueryingCardStatus = true;
    this.cardsService.getGpsCardStatus(this.card.token).subscribe(gpsCardStatus => {
      this._isQueryingCardStatus = false;
      this.currentGpsStatus = gpsCardStatus;
    }, err => {
      this._isQueryingCardStatus = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  upgradeKingToKingPlus() {

    this.dialog.open(ConfirmDialogComponent, { data: { title: 'Upgrade card', text: 'Are you sure you want to upgrade card '+this.card.token+' to king+?' } })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          this._isUpgradingCard = true;
          this.cardsService.upgradeCard(this.card.token, 'king', 'kingplus').subscribe(upgradeResult => {
            this._isUpgradingCard = false;
            this._toastService.success('Card has been upgraded to king+');
            this.loadData();
            // reload data
          }, err => {
            this._isUpgradingCard = false;
            this._toastService.error(err.error.message || err.error || err.message || err);
          });
        }
      });



  }


  queryCardFeeGroupFromPortal() {
    this._isQueryingCardFees = true;
    this.cardsService.getGpsCardFeeGroup(this.card.token).subscribe(gpsFeeGroup => {
      this._isQueryingCardFees = false;
      this.cardFeeGroup = gpsFeeGroup;
    }, err => {
      this._isQueryingCardFees = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  queryCardPermsGroupFromPortal() {
    this._isQueryingCardPermsGroup = true;
    this.cardsService.getGpsCardPermsGroup(this.card.token).subscribe(gpsPermsGroup => {
      this._isQueryingCardPermsGroup = false;
      this.cardPermsGroup = gpsPermsGroup;
    }, err => {
      this._isQueryingCardPermsGroup = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  currentUserIsCompliance(): boolean {
 return this.roleService.hasRoles('compliance');
}
  currentUserIsComplianceManager(): boolean {
 return this.roleService.hasRoles('compliance_manager');
}
  currentUserIsFinanceManager(): boolean {
 return this.roleService.hasRoles('finance_manager');
}

  setCardFeeGroup(feeGroup: string) {
    this._isQueryingCardFees = true;
    this.cardsService.setGpsCardFees(this.card.token, feeGroup).subscribe(ok => {
      this.cardFeeGroup = feeGroup;
      this._toastService.success('Fee group set to ' + feeGroup);
      this._isQueryingCardFees = false;
    }, err => {
      this._toastService.error(err.error.message || err.message || err.error || err);
      this._isQueryingCardFees = false;

    });
  }

  changeCardProduct() {
    if ( this.newProductId == this.card.productId ) {
return;
}
    if ( this.newProductId == 0) {
return;
}

    let newProduct: Product|null = null;
    this.products.forEach((value, index) => {
      if ( this.newProductId == value.id) {
        newProduct = value;
      }

    });

    this.dialog.open( ConfirmDialogComponent, {data:{
        title: 'Confirm product change',
        text: 'Change card product from ' + this.card.product.internalName + ' to new product ' + newProduct.internalName,
        confirm: 'Ok',
        cancel: 'Cancel'
      }}).afterClosed().subscribe( result => {
      if ( result == 'ok' ) {

        this._isChangingProduct = true;

        this.cardsService.changeCardProduct(this.card.token, this.newProductId).subscribe(ok => {
          this.card.product = newProduct;
          this.card.productName = newProduct.name;
          this._isChangingProduct = false;

          this.loadData();
          this._toastService.success('The card\'s product has been changed');

        }, err => {
          this._isChangingProduct = false;
          this._toastService.error(err.error.message || err.message || err.error || err);
        });
      } else {
        this._toastService.info('Card product will not be changed');
      }
    } );


  }


  linkCard() {
    if ( this.card.primaryCardId == this.newPrimaryCardId ) {
return;
}
    if ( !this.newPrimaryCardId ) {
return;
}

    const newPrimaryCard = this.otherCards.filter(value => value.id == this.newPrimaryCardId)[0];
    if ( !newPrimaryCard) {
return;
}

    this.dialog.open( ConfirmDialogComponent, {data:{
        title: 'Confirm link cards',
        text: 'Are you sure you want to Link card ' + this.card.token + ' (secondary) to  ' + newPrimaryCard.token + ' (primary)? Once a card is a secondary card, it can never be a primary again',
        confirm: 'Ok',
        cancel: 'Cancel'
      }}).afterClosed().subscribe( result => {
      if ( result == 'ok' ) {

        this._isLinkingCard = true;

        this.cardsService.linkCards(this.card.id, newPrimaryCard.id).subscribe(ok => {
          this.card.primaryCardId = this.newPrimaryCardId;
          this.newPrimaryCardId = null;

          this.card.primaryToken = newPrimaryCard.token;
          this._isLinkingCard = false;

          this.loadData();
          this._toastService.success('The card has been linked to ' + newPrimaryCard.token);

        }, err => {
          this._isLinkingCard = false;
          this._toastService.error(err.error.message || err.message || err.error || err);
        });
      } else {
        this._toastService.info('Card will not be linked');
      }
    } );


  }

  balanceTransfer() {
    if ( this.card.id == this.balanceTransferDestinationCardId ) {
return;
}
    if ( !this.balanceTransferDestinationCardId ) {
return;
}

    const balanceTransferTarget = this.otherCards.filter(value => value.id == this.balanceTransferDestinationCardId)[0];
    if ( !balanceTransferTarget) {
return;
}

    this.dialog.open( ConfirmDialogComponent, {data:{
        title: 'Confirm balance transfer',
        text: 'Are you sure you want to transfer ' + this.card.token + '\'s balance to  ' + balanceTransferTarget.token + '?',
        confirm: 'Ok',
        cancel: 'Cancel'
      }}).afterClosed().subscribe( result => {
      if ( result == 'ok' ) {

        this._isBalanceTransferring = true;

        this.cardsService.balanceTransfer(this.card.id, balanceTransferTarget.id).subscribe(ok => {

          this._isBalanceTransferring = false;

          this.loadData();
          this._toastService.success('The card\'s balance has been transferred to ' + balanceTransferTarget.token);

        }, err => {
          this._isBalanceTransferring = false;
          this._toastService.error(err.error.message || err.message || err.error || err);
        });
      } else {
        this._toastService.info('Card will not be linked');
      }
    } );

  }

  setWhiteList(listCode: string) {
    this.isQueryingWhiteList = true;
    this.cardsService.setWhiteList(this.card.token, listCode).subscribe(ok => {
      this.isQueryingWhiteList = false;
      this._toastService.success('Card ' + this.card.token + ' white list was set to ' + listCode);

      this.currentWhiteList = listCode;

    }, err => {
      this.isQueryingWhiteList = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }

  setBlackList(listCode: string) {
    this.isQueryingBlackList = true;
    this.cardsService.setBlackList(this.card.token, listCode).subscribe(ok => {
      this.isQueryingBlackList = false;
      this._toastService.success('Card ' + this.card.token + ' black list was set to ' + listCode);

      this.currentBlackList = listCode;

    }, err => {
      this.isQueryingBlackList = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }
}
